const platforms = [
  {
    name: "Jira",
    url: "https://unihack.atlassian.net/jira/software/c/projects/UNI/boards/2",
    inviteLink: false,
    icon: "FaJira",
  },
  {
    name: "GitHub",
    url: "https://discord.gg/HvfguBsu",
    inviteLink: false,
    icon: "FaGithub",
  },
  {
    name: "Discord",
    url: "https://discord.gg/HvfguBsu",
    inviteLink: true,
    icon: "FaDiscord",
  },
  {
    name: "Slack",
    url: "https://join.slack.com/t/slack-tgg5480/shared_invite/zt-14cx5m6ar-Rg~l9LxX~MJF7g5G8ZcBTA",
    inviteLink: true,
    icon: "FaSlack",
  },
  {
    name: "Microsoft Teams",
    icon: "FaMicrosoft",
  },
  {
    name: "Bitbucket",
    icon: "FaBitbucket",
  },
  {
    name: "Figma",
    icon: "FaFigma",
  },
  {
    name: "Google",
    icon: "FaGoogle",
  },
  {
    name: "Trello",
    icon: "FaTrello",
  },
];

export default platforms;
